import React, { Component } from 'react';
import axios from 'axios';
import $ from 'jquery';
import { toast } from 'react-toastify';
import bindModel from '../../../common/bindModel.js';

export default class ModalUpdateSinger extends Component {
    constructor(props) {
        super(props);
        this.state = {
            artist: {
                name: '',
                description: '',
                avatarUrl: '',
                type: 1,
                songCount: 0,
                status: 'ACTIVE'
            },
            loading: false
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleAvatarUrlChange = this.handleAvatarUrlChange.bind(this);
        this.guid = this.guid.bind(this);
    }

    guid() {
        function s4() {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
        }
        return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
    }

    handleAvatarUrlChange(e) {
        const target = e.target;
        const file = target.files[0];
        
        if (!file) return;

        // Validate file type
        if (!file.type.startsWith('image/')) {
            toast.warning('Vui lòng chọn file ảnh');
            return;
        }

        // Validate file size (max 5MB)
        if (file.size > 5 * 1024 * 1024) {
            toast.warning('Kích thước file không được vượt quá 5MB');
            return;
        }

        this.setState({ loading: true });

        const bucketName = "ikara-data/images/karaoke-artists";
        const extension = file.name.split('.').pop().toLowerCase();
        const keyName = this.guid() + "." + extension;
        let contentType = "image/jpeg";
        if (extension === "png") contentType = "image/png";
        if (extension === "gif") contentType = "image/gif";
        if (extension === "webp") contentType = "image/webp";

        const fileReader = new FileReader();

        fileReader.onload = function () {
            const fd = new FormData();
            fd.append('file', file);
            fd.append('bucketName', bucketName);
            fd.append('objectKey', keyName);
            fd.append('contentType', contentType);
            
            $.ajax({
                url: global.config.apiDomain + '/web.UploadFile',
                data: fd,
                processData: false,
                contentType: false,
                type: 'POST',
                success: function (data) {
                    this.setState({
                        loading: false
                    });

                    const imageUrl = 'https://data4.ikara.co/data/minio/' + bucketName + '/' + keyName;
                    this.setState({
                        artist: {
                            ...this.state.artist,
                            avatarUrl: imageUrl
                        }
                    });
                    toast.success('Upload ảnh thành công');
                }.bind(this),
                error: function (xhr, status, error) {
                    console.error('Error:', error);
                    this.setState({
                        loading: false
                    });
                    toast.error('Lỗi khi upload ảnh. Vui lòng thử lại.');
                }.bind(this)
            });
        }.bind(this);

        fileReader.readAsArrayBuffer(file);
    }

    componentWillReceiveProps(nextProps) {
        const { artist } = nextProps;
        
        if (artist) {
            this.setState({
                artist: {
                    id: artist.id,
                    name: artist.name || '',
                    description: artist.description || '',
                    avatarUrl: artist.avatarUrl || '',
                    type: artist.type || 1,
                    songCount: artist.songCount || 0,
                    status: artist.status || 'ACTIVE'
                }
            });
        } else {
            this.setState({
                artist: {
                    name: '',
                    description: '',
                    avatarUrl: '',
                    type: 1,
                    songCount: 0,
                    status: 'ACTIVE'
                }
            });
        }
    }

    handleSubmit() {
        const { artist } = this.state;
        const { onSuccess } = this.props;

        // Validation
        if (!artist.name || artist.name.trim() === '') {
            toast.warning('Vui lòng nhập tên ca sĩ');
            return;
        }

        if (!artist.avatarUrl || artist.avatarUrl.trim() === '') {
            toast.warning('Vui lòng nhập URL avatar hoặc upload ảnh');
            return;
        }

        this.setState({ loading: true });

        const isUpdate = artist.id;
        const url = isUpdate 
            ? `${global.config.apiDomain}/yt-song/web/artist/${artist.id}`
            : `${global.config.apiDomain}/yt-song/web/artist`;

        const method = isUpdate ? 'put' : 'post';
        const data = {
            name: artist.name.trim(),
            description: artist.description || '',
            avatarUrl: artist.avatarUrl.trim(),
            type: artist.type || 1,
            songCount: isUpdate ? (artist.songCount || 0) : 0,
            status: isUpdate ? (artist.status || 'ACTIVE') : 'ACTIVE' // Mặc định ACTIVE khi tạo mới
        };

        axios[method](url, data)
            .then(res => {
                this.setState({ loading: false });
                toast.success(isUpdate ? 'Cập nhật ca sĩ thành công' : 'Tạo ca sĩ thành công');
                window.$('#ModalUpdateSinger').modal('hide');
                if (onSuccess) {
                    onSuccess();
                }
            })
            .catch(error => {
                this.setState({ loading: false });
                const errorMessage = error.response?.data?.message || error.message || 'Đã xảy ra lỗi';
                toast.error(errorMessage);
            });
    }

    render() {
        const model = bindModel(this);
        const { artist, loading } = this.state;
        const isUpdate = !!artist.id;

        return (
            <div className="modal fade" id="ModalUpdateSinger" tabIndex={-1} role="dialog" aria-labelledby="ModalUpdateSingerTitle" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header bg-primary text-white">
                            <h5 className="modal-title" id="ModalUpdateSingerTitle">
                                {isUpdate ? 'Cập nhật ca sĩ' : 'Thêm ca sĩ mới'}
                            </h5>
                            <button type="button" className="close text-white" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="form-group">
                                <label htmlFor="artistName">
                                    <strong>Tên ca sĩ <span className="text-danger">*</span></strong>
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="artistName"
                                    placeholder="Nhập tên ca sĩ"
                                    {...model('artist.name')}
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="artistDescription">
                                    <strong>Mô tả</strong>
                                </label>
                                <textarea
                                    className="form-control"
                                    id="artistDescription"
                                    rows="3"
                                    placeholder="Nhập mô tả về ca sĩ"
                                    {...model('artist.description')}
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="artistAvatarUrl">
                                    <strong>Avatar <span className="text-danger">*</span></strong>
                                </label>
                                <div className="input-group">
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="artistAvatarUrl"
                                        placeholder="URL avatar hoặc upload ảnh"
                                        {...model('artist.avatarUrl')}
                                    />
                                    <div className="input-group-append">
                                        <label className="btn btn-outline-secondary mb-0" style={{ cursor: 'pointer' }}>
                                            <i className="fa-solid fa-upload mr-1"></i>
                                            Upload
                                            <input
                                                type="file"
                                                accept="image/*"
                                                style={{ display: 'none' }}
                                                onChange={this.handleAvatarUrlChange}
                                            />
                                        </label>
                                    </div>
                                </div>
                                {artist.avatarUrl && (
                                    <div className="mt-2">
                                        <img 
                                            src={artist.avatarUrl} 
                                            alt="Preview"
                                            style={{ 
                                                maxWidth: '150px', 
                                                maxHeight: '150px',
                                                borderRadius: '8px',
                                                border: '1px solid #ddd'
                                            }}
                                            onError={(e) => {
                                                e.target.style.display = 'none';
                                            }}
                                        />
                                    </div>
                                )}
                                <small className="form-text text-muted">
                                    Bạn có thể nhập URL avatar hoặc upload ảnh từ máy tính.
                                </small>
                            </div>

                            <div className="row">
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label htmlFor="artistType">
                                            <strong>Loại</strong>
                                        </label>
                                        <select
                                            className="form-control"
                                            id="artistType"
                                            value={artist.type || 1}
                                            onChange={(e) => {
                                                this.setState({
                                                    artist: {
                                                        ...artist,
                                                        type: parseInt(e.target.value, 10)
                                                    }
                                                });
                                            }}
                                        >
                                            <option value={1}>Ca sĩ</option>
                                            <option value={2}>Giáo viên</option>
                                        </select>
                                    </div>
                                </div>
                                {/* {isUpdate && (
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor="artistSongCount">
                                                <strong>Số bài hát</strong>
                                            </label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                id="artistSongCount"
                                                placeholder="0"
                                                min="0"
                                                {...model('artist.songCount')}
                                            />
                                        </div>
                                    </div>
                                )} */}
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button 
                                type="button" 
                                className="btn btn-secondary" 
                                data-dismiss="modal"
                                disabled={loading}
                            >
                                Hủy
                            </button>
                            {loading ? (
                                <button type="button" className="btn btn-primary" disabled>
                                    <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                                    Đang xử lý...
                                </button>
                            ) : (
                                <button 
                                    type="button" 
                                    className="btn btn-primary" 
                                    onClick={this.handleSubmit}
                                >
                                    <i className="fa-solid fa-check mr-2"></i>
                                    {isUpdate ? 'Cập nhật' : 'Tạo mới'}
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

